import { useDispatch } from 'react-redux';
import { easySnackbar } from '../store/Noti/noti.actions';
import { getFromObj } from '../util/lang';
import { useHistory } from 'react-router-dom';
import axios from '../axios-default';
import { ROLE_NAMES } from '../util/const';
import useAuth from './useAuth';
import { useMemo } from 'react';

const CASE_ACTIONS = {
    CANCEL: 'CANCEL',
    UNCANCEL: 'UNCANCEL',
};

const useAdmin = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const auth = useAuth();

    const allowCaseAction = useMemo(() => {
        if (!auth || !auth.user || !auth.user.role) return false;
        return [ROLE_NAMES.admin, ROLE_NAMES.super_admin].includes(auth.user.role);
    }, [auth.user.role]);

    const reloadPage = () => {
        let historyLoc = history.location.pathname;
        history.push('/blank');
        history.replace(historyLoc);
    };

    const handleCancelCase = async (caseId = 0, cancel_flag = null) => {
        try {
            console.log('Handling cancel case:', { caseId, cancel_flag });
            if (!caseId) throw new Error('Invalid case ID');
            if (typeof cancel_flag !== 'boolean') throw new Error('Invalid cancel flag');
            const action = cancel_flag ? CASE_ACTIONS.UNCANCEL : CASE_ACTIONS.CANCEL;
            if (action === CASE_ACTIONS.UNCANCEL && auth.user.role !== ROLE_NAMES.super_admin) {
                throw new Error('Only super admin can uncancel a case');
            }
            const endPointSuffix = cancel_flag ? 'uncancel' : 'cancelled';
            const question = `Are you going to ${cancel_flag ? 'uncancel' : 'cancel'} this case?`;
            const prompt = cancel_flag ? 'Please Input Reason (optional):' : 'Please Input Reason:';

            if (window.confirm(question)) {
                const userInput = window.prompt(prompt);
                if (userInput === null) return; // User clicked cancel, do nothing
                if (action === CASE_ACTIONS.CANCEL && !userInput.trim().length) {
                    dispatch(easySnackbar('Please Input Cancel Reason.', 'error'));
                    return;
                }
                const { data: result } = await axios.post(`case/${caseId}/${endPointSuffix}`, {
                    reason: userInput,
                    action: action,
                });
                if (result.success) {
                    dispatch(easySnackbar('Success', 'success', true));
                    reloadPage();
                } else {
                    console.error(result.message);
                    dispatch(easySnackbar(result.message, 'error'));
                }
            }
        } catch (error) {
            console.error(error);
            dispatch(easySnackbar(getFromObj(error, 'response.data.message') || error.message || error, 'error'));
        }
    };

    return {
        handleCancelCase,
        allowCaseAction,
    };
};

export default useAdmin;
